module.exports = __webpack_public_path__ + "static/img/empty.eb4c555.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/empty.png
// module id = 847
// module chunks = 1